import React from "react";
import { Window, Connect } from "../components/UI";
export default function About() {
  return (
    <div className="page about-page">
      <p className="eyebrow">A SMALL PROJECT FOR BIG LITTLE ADVENTURES</p>
      <h1>
        For the love
        <br />
        <em>of getting out.</em>
      </h1>
      <p className="about-intro">
        Strava Wrapped is a little space to appreciate the miles, moments, and
        everyday effort that make up a year. Built by{" "}
        <a href="https://ankitagrawal.com">Ankit Agrawal ↗</a>.
      </p>
      <Window title="read_me.txt">
        <div className="panel-content prose">
          <h2>Your data, your call.</h2>
          <p>
            We request read-only access to your Strava profile and activities.
            We don’t create or edit activities, and your recap isn’t published
            automatically.
          </p>
          <p>
            Your connection tokens are encrypted in an HTTP-only session cookie.
            Your imported activity data is held in this browser tab’s memory and
            cleared when you sign out or close the tab. The connection cookie
            expires after seven days. This site uses Vercel Analytics for
            website usage measurements.
          </p>
          <p>
            “Sign out” clears this website’s session. To revoke its access to
            Strava entirely, remove the application in{" "}
            <a
              href="https://www.strava.com/settings/apps"
              target="_blank"
              rel="noreferrer"
            >
              your Strava app settings ↗
            </a>
            . Strava’s own{" "}
            <a href="https://www.strava.com/legal/privacy">privacy policy</a>{" "}
            applies to its service.
          </p>
          <h2 id="connection-help">Need a hand connecting?</h2>
          <details open>
            <summary>Strava won’t open or the connection is cancelled</summary>
            <p>
              Try connecting again and allow activity access. If your browser
              shows “blocked by client,” check whether a browser extension or
              network policy blocks Strava. You can also try your usual browser.
            </p>
          </details>
          <details>
            <summary>Activities are missing</summary>
            <p>
              Choose the correct year and switch the sport filter to “All
              activities.” Private activities require permission on Strava.
              Indoor and manual activities appear in your recap, but activities
              without GPS won’t appear in route art.
            </p>
          </details>
          <details>
            <summary>Strava’s request limit has been reached</summary>
            <p>
              The app shows a wait time from Strava’s rate-limit information.
              Wait for that limit to reset before retrying. Changing pages
              repeatedly won’t help.
            </p>
          </details>
          <details>
            <summary>
              Strava says the app isn’t available to this athlete
            </summary>
            <p>
              Strava limits how many athletes an application can connect. The
              site owner needs to check the athlete capacity in the Strava API
              dashboard. Reconnecting won’t bypass that limit.
            </p>
          </details>
          <details>
            <summary>Strava is blocking this app’s API access</summary>
            <p>
              Strava requires Standard Tier developers to have an active
              subscription. If the app owner’s access has expired, athletes
              cannot load activities even when sign-in succeeds. The site owner
              should check their subscription and developer account in Strava’s
              API settings. You can still explore the demo.
            </p>
          </details>
          <details>
            <summary>The connection setup is still in progress</summary>
            <p>
              The site owner needs to configure the server credentials and the
              matching callback domain in Strava’s API settings. You can explore
              the demo while setup is completed.
            </p>
          </details>
          <Connect />
          <p className="fine-print">
            Independent project. Not affiliated with or endorsed by Strava.
          </p>
        </div>
      </Window>
    </div>
  );
}
